import React from 'react';
import { motion } from 'framer-motion';
import marieImage from '../assets/Marie_detoure.png';
import './About.css';

function About() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.4, 0, 0.2, 1]
      }
    }
  };

  return (
    <motion.div
      className="about"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <div className="about-container">
        <motion.div className="about-header" variants={itemVariants}>
          <h1 className="about-title">Profil</h1>
          <div className="about-decorative-line"></div>
        </motion.div>

        <div className="about-content">
          <motion.div className="about-image-section" variants={itemVariants}>
            <div className="about-image-wrapper">
              <img
                src={marieImage}
                alt="Marie Mercier"
                className="about-image"
              />
            </div>
          </motion.div>

          <div className="about-text-section">
            <motion.div className="about-intro" variants={itemVariants}>
              <p className="about-intro-text">
                Chargée de communication et Designer graphique, je crée des identités visuelles 
                épurées où chaque détail compte. Mon approche allie esthétique minimaliste 
                et sensibilité artistique.
              </p>
            </motion.div>

            <motion.div className="about-section" variants={itemVariants}>
              <div className="about-section-header">
                <span className="about-section-number">01</span>
                <h2 className="about-section-title">Formation</h2>
                <div className="about-section-line"></div>
              </div>
              <div className="about-section-content">
                <div className="about-item">
                  <span className="about-item-year">2025</span>
                  <div className="about-item-content">
                    <h3 className="about-item-title">Mastère direction artistique et numérique</h3>
                    <p className="about-item-subtitle">Studi · Design graphique</p>
                  </div>
                </div>
                <div className="about-item">
                  <span className="about-item-year">2014 — 2017</span>
                  <div className="about-item-content">
                    <h3 className="about-item-title">Licence Design graphique</h3>
                    <p className="about-item-subtitle">LISAA - L'Institut Supérieur des Arts Appliqués</p>
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div className="about-section" variants={itemVariants}>
              <div className="about-section-header">
                <span className="about-section-number">02</span>
                <h2 className="about-section-title">Expérience</h2>
                <div className="about-section-line"></div>
              </div>
              <div className="about-section-content">
                <div className="about-item">
                  <span className="about-item-year">déc. 2020 —</span>
                  <div className="about-item-content">
                    <h3 className="about-item-title">Chargée de communication</h3>
                    <p className="about-item-subtitle">Fondation de la maison du Diaconat de Mulhouse</p>
                  </div>
                </div>
                <div className="about-item">
                  <span className="about-item-year">nov. 2017 — déc. 2020</span>
                  <div className="about-item-content">
                    <h3 className="about-item-title">Chargée de communication</h3>
                    <p className="about-item-subtitle">Maison de la Famille Colmar · CDI</p>
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div className="about-section" variants={itemVariants}>
              <div className="about-section-header">
                <span className="about-section-number">03</span>
                <h2 className="about-section-title">Expertises</h2>
                <div className="about-section-line"></div>
              </div>
              <div className="about-section-content">
                <div className="about-expertise-list">
                  <div className="about-expertise-item">
                    <span className="about-expertise-dot"></span>
                    <span>Identité visuelle</span>
                  </div>
                  <div className="about-expertise-item">
                    <span className="about-expertise-dot"></span>
                    <span>Direction artistique</span>
                  </div>
                  <div className="about-expertise-item">
                    <span className="about-expertise-dot"></span>
                    <span>Édition & Typographie</span>
                  </div>
                  <div className="about-expertise-item">
                    <span className="about-expertise-dot"></span>
                    <span>Packaging design</span>
                  </div>
                  <div className="about-expertise-item">
                    <span className="about-expertise-dot"></span>
                    <span>Branding</span>
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div className="about-section" variants={itemVariants}>
              <div className="about-section-header">
                <span className="about-section-number">04</span>
                <h2 className="about-section-title">Clients</h2>
                <div className="about-section-line"></div>
              </div>
              <div className="about-section-content">
                <p className="about-clients-text">
                  Maisons de luxe, marques de mode, galeries d'art, éditeurs culturels. 
                  Une sélection de collaborations qui reflètent mon engagement pour 
                  l'excellence et l'élégance.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default About;

